import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { HomeRouter } from './home/HomeRouter';
import { PositionsMain } from './positions';
import { ApplicantsMain } from './applicants';
import { ClientsMain } from './clients';
import { UsersMain } from './users';
import { ProfileMain } from './profile';
import { Header, Sidebar } from './common';

export const Landing = () => {
  return (
    <div>
      <Header />
      <Sidebar />
      <div className="main-content">
        <Switch>
          <Route path={`/home`} component={HomeRouter} />
          <Route path={`/positions`} component={PositionsMain} />
          <Route path={`/applicants`} component={ApplicantsMain} />
          <Route path={`/clients`} component={ClientsMain} />
          <Route path={`/users`} component={UsersMain} />
          <Route path={`/profile`} component={ProfileMain} />
          {/* <Redirect exact path={`/`} to={`/positions`} /> */}
        </Switch>
      </div>
    </div>
  );
};
